import { render, staticRenderFns } from "./TextButton2.vue?vue&type=template&id=9923dce6&scoped=true"
import script from "./TextButton2.vue?vue&type=script&lang=js"
export * from "./TextButton2.vue?vue&type=script&lang=js"
import style0 from "./TextButton2.vue?vue&type=style&index=0&id=9923dce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9923dce6",
  null
  
)

export default component.exports